<template>
  <div id="firstName">
    <b-form-input
      v-model="firstName"
      type="text"
      required
      ref="input"
      placeholder="Hélène"
      :class="{ 'border-bottom-blue text-blue': isFirstNameSet }"
      class="mb-0 pl-0 ml-0 box-shadow-none"
      debounce="700"
      :autofocus="this.$router.currentRoute.name != 'dashboard'"
    ></b-form-input>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isFirstNameSet"]),
    firstName: {
      get() {
        return this.$store.state.userData.firstName;
      },
      set(value) {
        if (value != null && value != "") {
          this.$store.commit("SET_FIRST_NAME", value);
        } else {
          this.$store.commit("SET_FIRST_NAME", null);
        }
      },
    },
  },
  methods: {
    focus() {
      this.$refs.input.$el.focus();
    },
    setHasInputBeenChanged(value) {
      this.$store.commit("SET_HAS_INPUT_BEEN_CHANGED", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/forms.scss";

input {
  @include media-breakpoint-up(md) {
    width: 18rem;
  }
  margin-left: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
